<!--
* UIID: UI-CAAS-COM-114
* UI Name: POP3
* Modify Date: 2020/06/15
-->
<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4">
        <!-- First Row -->
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.pop3') }}
            </font>
            <v-text-field
              v-model="formData.name"
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              :error-messages="formError.name.message"
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
          <!-- // 2021.8.30 203728 SPKA-201 remove partner from communication -->
          <!-- <v-col cols="12" md="4">
            <v-select
              v-model="formData.partner"
              :items="partners"
              :placeholder="$t('lbl.common.conditionSearch.selectPartner')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
          <!-- 203665 2021/03/03
            SPKA-44 Remove Direction on screen Communication 
          -->
          <!-- <v-col cols="12" md="4">
            <v-select
                v-model="formData.direction"
              :items="inouts"
              :placeholder="$t('lbl.common.conditionSearch.selectDirection')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
        </v-row>
        <!-- 2 Row 54px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Server Address</v-label>
            <v-text-field
              v-model="formData.host"
              :rules="[validationUtils.required, validationUtils.max(50)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="8" class="pr-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Security</v-label>
                <v-select
                  v-model="formData.security"
                  :items="securities"
                  :rules="[validationUtils.required]"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
                <v-text-field
                  v-model="formData.port"
                  type="number"
                  :rules="[validationUtils.required, validationUtils.max(5)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--3 Row 40px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>User ID</v-label>
            <v-text-field
              v-model="formData.userid"
              :rules="[validationUtils.required, validationUtils.max(200)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
            <v-text-field
              v-model="formData.password"
              :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="formData.showpassword ? 'text' : 'password'"
              @click:append="formData.showpassword = !formData.showpassword"
              :rules="[validationUtils.required, validationUtils.max(20)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
              @focus="handlePasswordType"
              @blur="handlePasswordType"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="6" class="pr-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.communications.exeInterval') }}</v-label
                >
                <v-text-field
                  v-model="formData.interval"
                  type="number"
                  :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="intervalDefault"
                  :items="intervals"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  return-object
                  class="select-interval"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="pr-0">
            <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
            <v-text-field
              v-model="formData.maxRetry"
              type="number"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    item: {
      default: Object,
    },
  },

  data() {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
    };
  },
  created() {
    this.formData = Object.assign({}, this.getInitData(), this.item);
    if (!this.formData.interval) {
      this.formData.interval = '30';
    }
    if (this.formData.password) this.formData.showpassword = false;
    this.loadFormData = Object.assign({}, this.getInitData(), this.item);
    if (this.loadFormData.password) this.loadFormData.showpassword = false;
    if (this.item.intervalType) {
      this.intervalDefault = this.intervals.filter(
        (item) => item.value === this.item.intervalType,
      )[0];
    }
  },

  watch: {
    item() {
      this.resetFormData();
      this.setFocus();
    },
  },

  methods: {
    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },
    async save() {
      if (this.formData.action == 'edit') {
        /* 
          2021/01/15 203665 workflow issue 21  send only edit Data to JSON
        */
        let editedData = getEditData(this.formData, this.loadFormData);
        editedData.id = this.formData.id;
        if (editedData.name === undefined) {
          editedData.name = this.formData.name;
        }
        if (this.intervalDefault.value) {
          this.formData.intervalType = this.intervalDefault.value;
          editedData.intervalType = this.intervalDefault.value;
        }
        editedData.protocol = this.formData.type;
        await this.$store.dispatch('editComm', this.formData);
        await this.sendActivate(this.formData.id, 'COM', editedData);
      } else {
        this.formData.type = 'POP3';
        await this.$store.dispatch('insertComm', this.formData);
      }
      this.resetFormData();
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        showpassword: true,
        path: '',
        interval: '',
        type: 'POP3',
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != "showpassword" && prop != "type") {
    //       if (this.formData[prop].trim() != "") {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      if (this.item.type == 'POP3') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
      }
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
  },
};
</script>
